export const translation_en = {
    heading: "TATA STRIVE | Karya Path",
    subHeading: "Skill Development Initiative of Tata Trusts",
    partnership: "Developed by Tata STRIVE",
    poweredBy: "Powered by Tata Communications",
    welcomeText: "Discover your  interests and  match your career!",
    mobileNumber: "Mobile Number",
    dob: "Date Of Birth",
    otp: "Get OTP",
    enterOTP: "Enter OTP",
    validateOTP: "Validate OTP",
    resendOTP: "Resend OTP",
    form_heading: "Let's start! Tell us about yourself!",
    firstName: "First Name",
    firstNamePlaceHolder: "Enter First Name",
    lastName: "Last Name",
    lastNamePlaceHolder: "Enter Last Name",
    qualification: "Qualification",
    gender: "Gender",
    pincode: "Pincode",
    pincodePlaceHolder:"Enter valid Pincode",
    village: "Village",
    villagePlaceHolder:"Enter Village Name",
    district: "District",
    districtPlaceHolder:"Select a district",
    districtPinPlaceHolder:"Enter Valid pincode",

    mailId: "Mail Id",
    mailIdPlaceHolder:"Enter Email Id",
    mandatoryFields: "*Mandatory fields",
    save: "Save",
    mobileInputError: "* Exactly 10 digits",
    pincodeInputError: "* Exactly 6 digits",
    onlyNumbersError: "* Only Numbers",
    onlyCharError: "* Only Alphabets",
    noSpecialCharError: "* shouldnt include special characters",
    mailError: "* Invalid mail Id",
    dobError: "* Age should be more than 16 years",
    knowHowToPlayGame: "Before you start the game, it is important to know how to play the game.Please watch the video ",
    letsPlayGame: "Lets play the game !",
    confirmDialog: "Please Confirm!",
    yes:"Yes",
    no:"No",
    invalidCode: "Invalid OTP",
    ok: "ok",
    gamevideoConfirmation: "Hope you have seen the game instruction video",
    careervideoConfirmation: "Hope you have seen the career Report video",
    doYouLikeThis: "Do you like this",
    like:"Like",
    dislike: "Dislike",
    mayBe: "Maybe",
    congratulations: "Congratulations,",
    lookAtResults: "Let's take a look at your results",
    AfterGameMsg: "You just completed playing a career assessment designed to identify the jobs/career most suitable for you. A person’s interest in a particular work environment classifies him/her into a personality type. There are six personality types derived from Dr. John Holland's theory of careers and vocational choice, known as Holland Codes. Now based on your responses to the assessment your personality type/Holland code is",
    watchCareerVideo: "Watch video to understand your career report",
    clickHereButton: "Click Here",
    knowMoreAboutMatchingCareers : "to know about your most preferred personality type and matching career interest",
    ThankYouForPlayingGame: "Thank you for playing the game.",
    understandBetter: "Help us understand you better!",
    beforeChatBot: "Help us understand you better! You are just one step away from knowing your career interests. We will be showing you some situations. Select any one response that suits you the most.",
    clickToStart: "Click here to start",
    chatbotHeading: "Please complete questions to Help us understand you better!",
    noCoursesText: "Kindly follow the link to explore career options !",
    explore: "Explore",
    resultText1: "A person with a personality type",
    resultText2: ", is expected to flourish in the following professions.Click on each sector to explore further.",
    JobRole : "Job Role",
    sector: "Sector",
    recommendCounsellor: "We recommend you to reach our counsellor and understand your report better.",
    DownloadReport: "Download Report",
    reachToCounsellorButton: "Reach Out for Counselling",
    thankYouForCounsellorRequest: "Thank you for your request.Our counsellor will connect to you soon",
    contactUs1: "For queries, contact us on toll free number",
    csNumber: "1800-419-2112",
    contactUs2: "during working days, 10:00 am - 05:00 pm",
    contactUs3: " ", 
    askFeedback: "Did you like the game ?",
    thankYouForFeedback: "Thank you for your valuable feedback !",
    dear : "Dear",
    alertPageResultMsg:"You have completed all steps, Let's take a look at your results. Based on your responses to the assessment your personality type/Holland code is -",
    internetError: "Please wait.Page is loading.",
    confirmReplayOption: "Replaying the game will give you a new career report when you finish playing. Do you still want to continue?",
    ReplayGame: "Replay Game",
    gameVideo:"Ir2Wp8Gt4bc",
    beforeNameHappyText:"Happy to know you",
    afterNameHappyText:""  ,
    invalidPincode:"Please provide a valid pincode",
    interestedCourse: 'Interested Course',
  nearestCenter: 'Nearest Center'
};